/**
 * Auto-Skip-Vorschlags-Button (Z3 Plex-Parity, Netflix-Pattern).
 *
 * Semantik der media_skip_regions im Player:
 *   enabled=1 + mode=skip   → Region-Engine skippt HART (state-machine.js),
 *                             kein Button — das ist user-kuratiertes Verhalten.
 *   enabled=0 + source=auto_* → Server-DETEKTION (zap-intro-detect legt
 *                             auto_intro bewusst mit enabled=0 an): wir
 *                             zeigen einen Button, der User entscheidet.
 *   enabled=0 + source=user → vom User explizit deaktiviert: KEIN Button.
 */

const MIN_REGION_SEC = 3;       // kuerzere Detektionen sind Rauschen
const CREDITS_WINDOW_SEC = 240; // Region endet im letzten ~4-min-Fenster → Abspann

export function createSkipUi({ stage, video, fadeAndSkip }) {
  const btn = document.createElement('button');
  btn.className = 'zap-skipbtn';
  btn.type = 'button';
  btn.hidden = true;
  stage.appendChild(btn);

  let current = null;
  // Nach Klick bleibt die Position bis zu ~500 ms in der Region (createFader
  // seekt erst nach dem Audio-Fade-out) — ohne Merker wuerde der naechste
  // timeupdate den Button sofort wieder einblenden (Review-Befund: Blinken).
  // dismissed unterdrueckt das Re-Show, bis die Position die Region verlassen
  // hat; manueller Seek zurueck in die Region zeigt ihn danach wieder.
  let dismissed = null;

  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    if (!current) return;
    dismissed = current;
    fadeAndSkip(current.end);
    hide();
  });

  function labelFor(r) {
    const l = String(r.label || '').toLowerCase();
    if (/intro|opening|vorspann/.test(l)) return 'Intro überspringen';
    const nearEnd = Number.isFinite(video.duration) && video.duration > 0
      && r.end >= video.duration - CREDITS_WINDOW_SEC;
    if (/credit|abspann|outro|ending/.test(l) || nearEnd) return 'Abspann überspringen';
    return 'Überspringen';
  }

  function hide() {
    btn.hidden = true;
    current = null;
  }

  /** Pro timeupdate: passende Vorschlags-Region suchen, Button togglen. */
  function update(regions, t) {
    let hit = null;
    for (const r of (regions || [])) {
      if (r.enabled) continue;
      if (!/^auto_/.test(String(r.source || ''))) continue;
      if ((r.mode || 'skip') !== 'skip') continue;
      if ((r.end - r.start) < MIN_REGION_SEC) continue;
      // 0.5s vor Region-Ende ausblenden — ein Skip dorthin lohnt nicht mehr
      if (t >= r.start && t < r.end - 0.5) { hit = r; break; }
    }
    if (!hit) { dismissed = null; if (current) hide(); return; }
    if (dismissed && dismissed.id === hit.id) return;   // Klick-Skip in flight
    if (current && current.id === hit.id && !btn.hidden) return;
    current = hit;
    btn.textContent = labelFor(hit);
    btn.hidden = false;
  }

  return { update, hide, destroy: () => btn.remove(), el: btn };
}
